/**
 * @generated SignedSource<<149d0804af84aab59abb3c3e75185d0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type PreviewWidgetFlourishPraiseIntegrationInput = {
  size?: WidgetOverviewSize | null;
  storecastId?: string | null;
};
export type WAIntegrationFlourishPraiseQuery$variables = {
  input: PreviewWidgetFlourishPraiseIntegrationInput;
  storecastId: string;
};
export type WAIntegrationFlourishPraiseQuery$data = {
  readonly dashboard: {
    readonly previewWidgetFlourishPraiseIntegration: {
      readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise">;
    } | null;
  };
};
export type WAIntegrationFlourishPraiseQuery = {
  response: WAIntegrationFlourishPraiseQuery$data;
  variables: WAIntegrationFlourishPraiseQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAIntegrationFlourishPraiseQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v3/*: any*/),
              "concreteType": "WidgetIntegrationFlourishPraise",
              "kind": "LinkedField",
              "name": "previewWidgetFlourishPraiseIntegration",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAIntegrationFlourishPraiseQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "WidgetIntegrationFlourishPraise",
            "kind": "LinkedField",
            "name": "previewWidgetFlourishPraiseIntegration",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "overviewSize",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetIntegrationFlourishPraiseLeaderboardItem",
                "kind": "LinkedField",
                "name": "flourishTeams",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "praise",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "71354bb930b94d1712ef91864fac3fc4",
    "id": null,
    "metadata": {},
    "name": "WAIntegrationFlourishPraiseQuery",
    "operationKind": "query",
    "text": "query WAIntegrationFlourishPraiseQuery(\n  $storecastId: ID!\n  $input: PreviewWidgetFlourishPraiseIntegrationInput!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetFlourishPraiseIntegration(input: $input) {\n      ...WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetIntegrationFlourishPraiseLeaderboardItem on WidgetIntegrationFlourishPraiseLeaderboardItem {\n  id\n  praise\n  title\n}\n\nfragment WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise on WidgetIntegrationFlourishPraise {\n  id\n  overviewSize\n  flourishTeams {\n    id\n    ...WidgetIntegrationFlourishPraiseLeaderboardItem\n  }\n}\n"
  }
};
})();

(node as any).hash = "62a591fcdf687b90d03a26dac3964435";

export default node;
